import template from './sw-cms-preview-product-slider.html.twig';
import './sw-cms-preview-product-slider.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
